<div class="error-container">
  <mat-icon class="error-container__icon">error_outlined</mat-icon>
  <div class="error-container__title">{{
    'EAB.COMMON.ERROR_TITLE' | i18n | async
  }}</div>
  <div class="error-container__description"
    >{{ 'EAB.COMMON.NOT_VALID_CALENDAR_ID' | i18n | async }}
  </div>
</div>
